import { makeAutoObservable } from "mobx";
import type { RootStore } from "./root.store";

/**
 * The project Gantt's UI state: the open work item, fullscreen, and the bar a
 * dependency drag started from. Its dependency edges are server data and live
 * in the shared cache (`queries/work-item-relations.ts`, NG-2812).
 */
export class TimelineStore {
  activeBlockId: string | null = null;
  isFullscreen = false;
  draggingDependencyFrom: string | null = null;

  constructor(_rootStore: RootStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setActiveBlock(id: string | null): void {
    this.activeBlockId = id;
  }

  setFullscreen(on: boolean): void {
    this.isFullscreen = on;
  }

  beginDependencyDrag(sourceIssueId: string): void {
    this.draggingDependencyFrom = sourceIssueId;
  }

  cancelDependencyDrag(): void {
    this.draggingDependencyFrom = null;
  }
}
